import { render, staticRenderFns } from "./contract-list.vue?vue&type=template&id=5c3a5b2a&"
import script from "./contract-list.vue?vue&type=script&lang=ts&"
export * from "./contract-list.vue?vue&type=script&lang=ts&"
import style0 from "./contract-list.vue?vue&type=style&index=0&id=5c3a5b2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports